module.exports = __webpack_public_path__ + "img/jiejie.21edb5fa.png";